module.exports = __webpack_public_path__ + "static/media/sasha-grey.454ce0bc.jpg";